/**
 * The used-car module's section strip is built by each list page; the admin "Správa" tab (the change
 * history, `historie_ojeta_vozidla`) is shared here: shown only to `ojeta_vozidla` admins once
 * membership resolves — the API (`/v1/historie/ojeta_vozidla`) is the boundary.
 */

import { useMemo } from 'react';
import { useModuleAccess } from '@/lib/permissions';

export type OjetaSpravaTab = { value: 'sprava'; label: string };

export function useOjetaSpravaTab(): OjetaSpravaTab[] {
  const { can, resolved } = useModuleAccess();
  const canAdmin = resolved && can('ojeta_vozidla', 'admin');
  return useMemo(() => (canAdmin ? [{ value: 'sprava' as const, label: 'Správa' }] : []), [canAdmin]);
}
